<template>
  <div>

    <card card-body-classes="" no-footer-line>
      <div slot="header">
        <h4  class="title title-up mb-0">
          Glimpses Volume: {{ newsletter.volume }} | Issue: {{ newsletter.issue }}
        </h4>
        <p class="text-muted">{{ date }}</p>
      </div>

      <div class="row">

        <div class="col-12 mt-2">
          <NewsCard 
            type="main"
            :news="newsletter.featured_news"
          ></NewsCard>
          <NewsCard 
            v-for="(item, index) in newsletter.news"
            :key="index"
            type="sub"
            :news="item"
          ></NewsCard>
        </div>
        
      </div>

    </card>

  </div>
</template>
<script>
import { Card, NewsCard } from 'src/components';

import { mapGetters } from 'vuex';

export default {
  components: {
    Card,
    NewsCard,
  },
  computed: {
    ...mapGetters({
        newsletter: 'getNewsletter'
    }),
    date: function(){
        if(this.newsletter){
            let date = new Date(this.newsletter.date)
            return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        }
        else{
            return ''
        }
    },
  },
  data() {
    return {
    }
  },
  methods: {
    
  },
  mounted() {
    this.$store.dispatch('getNewsletter', this.$route.params.id)
  },
  watch: {
    
  }
};
</script>

<style lang="scss">
.has-success.has-label:after, 
.has-danger.has-label:after {
    top: 43px;
}

.el-transfer-panel__filter.el-input{
  width: 85%;
}

.bootstrap-switch{
  display: block;
  width: 90px!important;
  height: 35px!important;

  &.bootstrap-switch-on{
      .bootstrap-switch-label{
          left: 70%;
      }
  }

  .bootstrap-switch-label{
      width: 35px!important;
      height: 35px!important;
  }

  .bootstrap-switch-handle-off,
  .bootstrap-switch-handle-on{
      font-weight: bold;
      line-height: 22px;
      text-indent: 10px;
      color: #273c75!important;
      width: 100%!important;
  }
  .bootstrap-switch-handle-off{
      text-indent: 15px;
  }
}

.ck-editor__editable {
  min-height: 300px;
  }

  .el-dialog__wrapper{
    position: fixed;
    height: 100vh;
    width: 50%;
    top: 0;
    right: 0px;
  }

  .news-drawer{
    .el-drawer__close-btn{
      outline: none;
    }

    .el-drawer__header{
      margin-bottom: 10px;
    }

    .el-drawer__body{
      padding: 5px 20px;

      label{
        display: none;
      }
    }

    .search-results{
      height: calc(100vh - 100px);
      overflow-y: auto;
    }
  }

</style>
